@if(showTagContent){
<div class="app__internal--links app__role--players--card mb-0">
  <mat-dialog-content class="mat-dialog-content">
    <mat-accordion class="prevent-click" [@.disabled]="true">
      <mat-expansion-panel class="attachment-tag relative shadow-none rounded-t-none rounded-b-none" hideToggle [disabled]="true" [expanded]="true">
        <mat-expansion-panel-header class="h-8 disable_ripple">
          <mat-panel-title>
            <div class="app__between--justified--content flex-row w-full">
              <p class="text-base m-0 font-bold text-[#010B18]">Document Tags</p>
              <!-- <button mat-mdc-button class="app__internal--links--add--btn app__centered-item w-fit leading-[34px]" (click)="manageTags()">
                <span class="material-icons text-base">add</span>
                <span class="relative"> Add New </span>
              </button> -->
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mt-2 px-1">
          <manage-tag-search
            [data]="filteredDocumentTypes"
            [attachmentTags]="this.attachmentTags.document_type"
            [placeHolder]="'Search Tags'"
            [errorMessage]="errorMessage"
            [disabled]="isRemoveEditSaveSharing"
            (selectionChange)="handleSelectedTag($event)"
            (newItemCreationdEventEmitter)="handleNewCustomTag($event)"
          ></manage-tag-search>
        </div>

        @if(attachmentTags.document_type.length > 0 || attachmentTags.document_suggestion_tag.length > 0){
        <div class="flex flex-col max-h-[286px] overflow-auto gap-2 mt-3 px-1">
          @if(attachmentTags.document_type.length > 0){ @for (tag of attachmentTags.document_type; track tag; let i = $index) {
          <div
            class="app__between--justified--content text-center min-h-[64px] border border-[#D3DCE8] border-solid rounded-lg pr-1 w-full"
            [ngClass]="{ 'pl-2': !isRemoveEditSaveSharing, 'pl-4': isRemoveEditSaveSharing }"
          >
            <div class="flex items-center w-[80%] overflow-hidden gap-1">
              <mat-checkbox
                *ngIf="!isRemoveEditSaveSharing"
                class="app__common--multiple--selection--checkbox"
                [(ngModel)]="tagSelectionState['document_type_' + i]"
                (change)="onTagSelectionChange('document_type', tag, i, $event.checked)"
                (click)="$event.stopPropagation()"
              >
              </mat-checkbox>
              <div class="flex items-center flex-1 gap-3">
                <img src="assets/images/attachment-tag-icon.svg" />
                <span class="app__form--attribute--title text-sm leading-[21px] font-semibold text-left text-truncate">{{ tag }}</span>
              </div>
            </div>
            <div class="flex items-center">
              <button
                [ngClass]="{ 'h-full text-[#25508E]': !isRemoveEditSaveSharing, 'h-full text-[#C1C2C5]': isRemoveEditSaveSharing }"
                mat-icon-button
                [matMenuTriggerFor]="documentMenu"
                [disableRipple]="true"
                [disabled]="isRemoveEditSaveSharing"
              >
                <span class="material-icons horiz">more_vert</span>
              </button>
              <mat-menu #documentMenu="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                <button mat-menu-item (click)="deleteVaultUserTag(tag)">
                  <span class="app__form--attribute--title items-center text-center font-semibold text-sm text-[#EB5757]">
                    <img class="relative top-[-2px] mr-1" src="assets/images/inbox/minus-circle.svg" />
                    Remove
                  </span>
                </button>
              </mat-menu>
            </div>
          </div>
          }} @if(attachmentTags.document_suggestion_tag.length > 0){ @for (tag of attachmentTags.document_suggestion_tag; track tag; let i = $index) {
          <div
            class="text-center border border-[#D3DCE8] border-solid rounded-lg pr-1 w-full"
            [ngClass]="{
              'app__between--justified--content min-h-[64px] ': true,
              'flex flex-col justify-between relative min-h-fit items-start ': false,
              'pl-2': !isRemoveEditSaveSharing,
              'pl-4': isRemoveEditSaveSharing
            }"
          >
            <div class="flex justify-between items-center w-full">
              <div class="flex items-center w-[80%] overflow-hidden gap-1">
                <mat-checkbox
                  *ngIf="!isRemoveEditSaveSharing"
                  class="app__common--multiple--selection--checkbox"
                  [(ngModel)]="tagSelectionState['tag_ai_suggestion_' + i]"
                  (change)="onTagSelectionChange('tag_ai_suggestion', tag, i, $event.checked)"
                  (click)="$event.stopPropagation()"
                >
                </mat-checkbox>
                <div class="flex items-center flex-1 gap-3">
                  <img src="assets/images/attachment-ai-tag-icon.svg" />
                  <div class="flex flex-col text-start w-full">
                    <span class="app__form--attribute--title text-sm leading-[21px] font-semibold text-truncate">{{ tag }}</span>

                    <span>
                      <p
                        class="text-[10px] font-medium m-0 text-base text-[#010B18]"
                        style="
                          background: linear-gradient(180deg, #3e75ff, #8400ff, #e367ff);
                          -webkit-background-clip: text;
                          font-size: 12px !important;
                          -webkit-text-fill-color: transparent;
                        "
                      >
                        Kinnect Ai Suggestion
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex items-center">
                <button
                  class="app__centered-item w-[56px] h-8 rounded"
                  [ngClass]="{ 'bg-[#25508E]': !isRemoveEditSaveSharing, 'bg-k-grey': isRemoveEditSaveSharing }"
                  [disabled]="isRemoveEditSaveSharing"
                  (click)="addUserTags(tag, true, true)"
                >
                  <span class="text-white font-semibold">Add</span>
                  @if (isTagLoading(tag)) {
                  <span class="content__loader w-[10px]">
                    <small-button-loader [width]="10" [height]="10"></small-button-loader>
                  </span>
                  }
                </button>

                <button
                  [ngClass]="{ 'h-full text-[#25508E]': !isRemoveEditSaveSharing, 'h-full text-[#C1C2C5]': isRemoveEditSaveSharing }"
                  mat-icon-button
                  [matMenuTriggerFor]="suggestionMenu"
                  [disableRipple]="true"
                  [disabled]="isRemoveEditSaveSharing"
                >
                  <span class="material-icons horiz">more_vert</span>
                </button>
                <mat-menu #suggestionMenu="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                  <button mat-menu-item (click)="removeDocumentSuggestionTag(tag)">
                    <span class="app__form--attribute--title items-center text-center font-semibold text-sm">
                      <img class="relative top-[-2px] mr-1" src="assets/images/inbox/Hide.svg" />
                      Hide suggestion
                    </span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
          }}
        </div>
        } @else{
        <div class="mt-3 px-1">
          <div class="app__centered-item flex-row text-center h-16 border rounded-lg border-[#d3dce8] border-solid">
            <img src="assets/images/document-tag.svg" />
            <span class="app__form--attribute--title font-semibold text-[12px] ml-2">
              No <span class="font-bold text-[#25508E]"> Document Tags</span> to show
            </span>
          </div>
        </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>
</div>
}
